// Phase 4 — Angular component replacing the AngularJS `RoleController`
// (sudo/access/RoleController.js + role.html, both DELETED).
//
// As of Phase 4.1 this is a NATIVE Angular component state (not a downgraded directive):
// the `sudo.role` / `employee.roles` states in ng/app.routes.ts route directly to it, and
// the angular-hybrid `UIViewNgUpgrade` bridge renders it into the ng1 parent's `<ui-view>`.
//
// It self-sources the `type` state param via UIRouterGlobals (the hybrid shares one router,
// so this reflects the current state).
//
// Phase 5: the Add Role modal is now a NATIVE Angular Material dialog (AddRoleComponent),
// opened via MatDialog. The Edit Role modal is STILL AngularJS, so it keeps opening through
// the upgraded `$uibModal` (NG1_UIB_MODAL token, wired in app.module.ts) as before.
import { Component, inject } from '@angular/core';
import type { OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { UIRouterGlobals } from '@uirouter/angular';
import { AccessService } from './access.service';
import { AddRoleComponent } from './add-role.component';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { NG1_UIB_MODAL, PB } from '../../upgrades';

@Component({
    selector: 'role-list',
    standalone: true,
    imports: [PageHeaderComponent, MatButtonModule, MatIconModule, MatListModule],
    templateUrl: './role-list.component.html',
    styleUrl: './role-list.component.css',
})
export class RoleListComponent implements OnInit {
    private access = inject(AccessService);
    private dialog = inject(MatDialog);
    private uibModal = inject(NG1_UIB_MODAL);
    private globals = inject(UIRouterGlobals);
    private pb = inject(PB);

    roles: any[] = [];

    private get type(): string {
        return this.globals.params['type'];
    }

    ngOnInit(): void {
        this.load();
    }

    private load(): void {
        this.access.fetchRoleList(this.type).then((data) => {
            this.roles = data;
        });
    }

    add(): void {
        this.dialog
            .open(AddRoleComponent, {
                width: '420px',
                disableClose: true,
                data: { type: this.type },
            })
            .afterClosed()
            .subscribe((created) => {
                if (created) this.load();
            });
    }

    edit(role: any): void {
        this.uibModal
            .open({
                controller: 'EditRoleController',
                templateUrl: this.pb + 'sudo/access/edit-role.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    role: () => ({
                        _id: role._id,
                        name: role.name,
                        type: role.type,
                        description: role.description,
                        rights: role.rights,
                        documentTypes: role.documentTypes,
                    }),
                },
            })
            .result.then(
                () => this.load(),
                () => this.load(),
            );
    }
}
